export const GET_LAB_REQUEST = 'GET_LAB_REQUEST';
export const GET_LAB_SUCCESS = 'GET_LAB_SUCCESS';
export const GET_LAB_FAILURE = 'GET_LAB_FAILURE';

